'use es6';

import I18n from 'I18n';
import { fromJS } from 'immutable';
import { hasMetricTypeCount } from './helpers';
import { getCurrencyCode } from '../salesExplorer';
const formatPercentage = percent => I18n.formatPercentage(percent, {
  precision: 2
});
const formatNumber = count => I18n.formatNumber(count);
const formatCurrency = (currencyValue, currencyCode) => I18n.formatIntlCurrency(currencyValue, {
  currencyCode
});
const formatMap = {
  number: formatNumber,
  percent: formatPercentage,
  currency: formatCurrency
};
const wrapFormatValues = (formatFn, value, currencyCode) => {
  if (value || value === 0) {
    return formatFn(value, currencyCode);
  }
  return NaN;
};
export const getSummaryProperties = ({
  report,
  datasets,
  response
}) => {
  const summaryDataset = datasets.getIn(['summary', 'data', 0]);
  if (summaryDataset) {
    const metrics_primary = summaryDataset.get('metrics_primary');
    const metrics_secondary = summaryDataset.get('metrics_secondary');
    return getCurrencyCode().then(currencyCode => {
      const formatType = hasMetricTypeCount(report) ? 'number' : 'currency';
      const updatedDatasets = datasets.setIn(['summary', 'properties'], fromJS({
        metrics_primary: {
          type: formatType,
          format: {
            currencyCode
          },
          references: {
            [metrics_primary]: {
              label: wrapFormatValues(formatMap[formatType], metrics_primary, currencyCode)
            }
          }
        },
        metrics_secondary: {
          type: 'percent',
          references: {
            [metrics_secondary]: {
              label: wrapFormatValues(formatMap['percent'], metrics_secondary, currencyCode)
            }
          }
        }
      }));
      return {
        report,
        response,
        datasets: updatedDatasets
      };
    });
  }
  return {
    report,
    response,
    datasets
  };
};